module.exports = __webpack_public_path__ + "static/media/DigiKuns_Thumbnail.0d375b6b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/DigiKuns_Thumbnail.jpg
// module id = 817
// module chunks = 3